<template>
  <v-dialog
    v-model="open"
    :max-width="maxWidth"
    :persistent="persistent || loading"
    :disabled="disabled"
    :eager="eager"
    :fullscreen="fullscreen"
    :light="light"
    :dark="dark"
    :retain-focus="retainFocus"
    :scrollable="scrollable"
    :transition="transition"
    :width="width"
  >
    <v-card>
      <v-toolbar flat :dark="!light" :color="headerColor" :max-height="headerMaxHeight">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <slot name="top-actions"></slot>
          <v-btn icon :dark="!light" @click="hide" :disabled="loading || persistent">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider v-if="headerSplit" />
      <v-card-text :class="bodyClasses">
        <slot></slot>
      </v-card-text>
      <v-card-actions :class="footerClasses">
        <slot name="bottom-actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AnchorModal',
  props: {
    bodyClasses: {
      type: String,
      default: 'mt-5 pb-0',
    },
    headerMaxHeight: {
      type: [String, Number],
      default: 64,
    },
    headerColor: {
      type: String,
      default: 'primary',
    },
    headerSplit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    footerClasses: {
      type: String,
      default: 'py-0',
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    origin: {
      type: String,
      default: 'center center',
    },
    retainFocus: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition',
    },
    width: {
      type: [String, Number],
      default: 'auto',
    },
    maxWidth: [Number, String],
    value: Boolean,
    loading: Boolean,
  },
  data: () => ({
    open: false,
  }),
  watch: {
    open(val) {
      if (val === true) {
        this.show();
      } else {
        this.hide();
      }
    },
    value(val) {
      this.open = val;
    },
  },
  methods: {
    show() {
      this.$emit('input', true);
    },
    hide() {
      this.$emit('input', false);
    },
  },
  mounted() {
    this.open = this.value;
  },
};
</script>
